import { ADD_GROWTHBOOK_EXPERIMENT } from '../../../constants/growthbookExperiments';

export const initialState = [];

const growthbookExperiments = (state = initialState, { type, payload }) => {
  if (type === ADD_GROWTHBOOK_EXPERIMENT) {
    return [...state, payload];
  }

  return state;
};

export default growthbookExperiments;

export const growthbookExperimentsSelector = (state) =>
  state?.app?.growthbookExperiments ?? initialState;
